export default __webpack_public_path__ + "static/media/_ic_doc_act.e71bcc69.svg";